import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Col } from 'react-bootstrap';
import { debounceIndexShiftsRequest } from '../../../requests/shifts';
import { camelCaseEmptyStringRecursive } from '../../../services/utils';
import ShiftFilters from './ShiftFilters';
import ShiftMonth from '../../Shift/ShiftMonth';
import ShiftRotative from '../../Shift/ShiftRotative';
import ShiftHours from '../../Shift/ShiftHours';
import ShiftForm from '../../Shift/ShiftForm';

const MyShiftsInfo = ({ user }) => {
  const dispatch = useDispatch();
  const employeeId = user?.employeeCard?.id;
  const shiftsLength = user?.employeeCard?.shifts?.length || 0;
  const [shifts, setShifts] = useState([]);
  const [shift, setShift] = useState(null);
  const [selectPlaceHolder, setSelectPlaceHolder] = useState('Cargando turnos...');
  const [isMulti, setIsMulti] = useState(shiftsLength > 1);

  const handleShiftSelected = values => {
    const shiftSelected = values.shift;
    if (shiftSelected) {
      setShift(shiftSelected);
    }
  };

  const fetchShifts = () => {
    if (employeeId == null) return;

    setSelectPlaceHolder('Cargando turnos...');
    debounceIndexShiftsRequest({
      dispatch,
      params: {
        active: true,
        filter_by_employee: employeeId,
        sort_column: 'name',
        paginate: false
      },
      successCallback: data => {
        const shiftsData = camelCaseEmptyStringRecursive(data.data.data);
        setShifts(shiftsData);
        // Si hay un solo turno, seleccionarlo automáticamente
        if (shiftsData.length === 1) {
          setIsMulti(true);
          setShift(shiftsData[0]);
        }
        setSelectPlaceHolder('Seleccione turno');
      }
    });
  };
  useEffect(fetchShifts, [employeeId]);

  const body = () => {
    switch (shift.shiftType) {
      case 'monthly':
        return <ShiftMonth shift={shift} action="edit" disabled rrhh={false} />;
      case 'rotative':
        return <ShiftRotative shift={shift} action="edit" disabled rrhh={false} />;
      case 'hours':
        return <ShiftHours shift={shift} action="edit" disabled rrhh={false} />;
      default:
        return <ShiftForm shift={shift} action="edit" disabled rrhh={false} />;
    }
  };

  return (
    <>
      {!isMulti && (
        <ShiftFilters shifts={shifts} formRequest={handleShiftSelected} selectPlaceHolder={selectPlaceHolder} />
      )}
      <Col sm={12} md={12} lg={12} className="mt-2 mb-4">
        {shift && body()}
      </Col>
    </>
  );
};

export default MyShiftsInfo;
